<template>
  <SimpleStackedChart
    :name="$t('Chart__NumberOfStudents__name')"
    :sheets="sheets"
  >
    <p class="fmhind-graph-number-of-students__source">
      {{ $t('Chart__NumberOfStudents__source') }}
    </p>
  </SimpleStackedChart>
</template>

<script>
import data from '@/assets/json/NumberOfStudents.json';
import SimpleStackedChart from '@/components/ChartPartials/SimpleStackedChart';

export default {
  name: 'NumberOfStudents',
  components: {
    SimpleStackedChart
  },
  data() {
    return {
      sheets: data
    };
  }
};
</script>

<style lang="scss">
.fmhind-graph-number-of-students__source {
  @extend %chart-source;
}
</style>
